import { BadmintonGameType } from './../../_shared/models/enums/badminton.enum';
import { BadmintonGameFormat } from './../../_shared/models/enums/badminton.enum';
import { FormGroup, FormBuilder, ReactiveFormsModule } from '@angular/forms';
import { Component, Input, EventEmitter, Output, inject, OnInit, OnDestroy } from '@angular/core';
import { ScoreFormat, SetType } from '../../_shared/models/score-format.model';
import { BoardHelpService } from '../../match-tracker/tracker-board/board-help.service';
import { DisciplineEnum } from '../../_shared/models/csTypes/enums/discipline';
import { IonicModule } from '@ionic/angular';
import { CommonModule } from '@angular/common';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { Subject, takeUntil } from 'rxjs';

@Component({
  selector: 'app-badminton-match-format-form',
  templateUrl: './badminton-match-format-form.component.html',
  styleUrls: ['./badminton-match-format-form.component.scss'],
  standalone: true,
  imports: [
    IonicModule,
    CommonModule,
    ReactiveFormsModule,
    TranslateModule
  ]
})

export class BadmintonMatchFormatFormComponent implements OnInit, OnDestroy {
  private readonly fb = inject(FormBuilder);
  private readonly bhs = inject(BoardHelpService);
  private readonly translateService = inject(TranslateService);
  private readonly destroy$: Subject<void> = new Subject();

  @Input() matchFormat = 'SET3-S:TB21@30';
  @Input() dividerTitle = this.translateService.instant('Score format');
  @Output() updatedMatchFormat = new EventEmitter();

  scoreFormat!: ScoreFormat;
  form!: FormGroup;

  private readonly capMapping: Record<number, number> = {
    11: 13,
    15: 20,
    21: 30,
  };

  ngOnInit() {
    this.initScoreFormat();
    this.buildForm();
  }

  private initScoreFormat(): void {
    this.scoreFormat = this.bhs.getScoreFormat(
      this.matchFormat,
      DisciplineEnum.BADMINTON
    );
  }

  buildForm() {
    const { numberOfSets, numberOfPointsInGame, timedSetDuration, capOfPoints } = this.scoreFormat;
    this.form = this.fb.group({
      gameType: [BadmintonGameType.RALLY],
      numberOfGames: [numberOfSets],
      numberOfPoints: [numberOfPointsInGame ?? 21],
      numberOfMinutes: [timedSetDuration ?? 15],
      gameFormat: [BadmintonGameFormat.WIN_BY_2],
      capOfPoints: [capOfPoints ?? null],
    });

    this.setupSubscriptions();
    this.emitMatchFormat(); // Initial emit
  
    this.form
      .valueChanges
      .subscribe(
        () => {
          this.updatedMatchFormat.emit(this.getMatchFormat());
        }
      );
  }
  private setupSubscriptions(): void {
    this.form.get('numberOfPoints')?.valueChanges
      .pipe(takeUntil(this.destroy$))
      .subscribe(points => {
        const cap = this.capMapping[points] ?? null;
        this.form.patchValue({ capOfPoints: cap }, { emitEvent: false });
      });

    this.form.valueChanges
      .pipe(takeUntil(this.destroy$))
      .subscribe(() => this.emitMatchFormat());
  }

  private emitMatchFormat(): void {
    this.updatedMatchFormat.emit(this.getMatchFormat());
  }

  // SET3-S:TB21@30 or SET3-S:TB21 (without cap)
  private getMatchFormat() {
    const { numberOfGames, numberOfPoints, capOfPoints } = this.form.getRawValue();
    const base = `SET${numberOfGames}-S:TB${numberOfPoints}`;
    return capOfPoints ? `${base}@${capOfPoints}` : base;
  }

  // Header for action sheet
   customOptions(header: string): { header: string } {
    return { header };
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
